import React from "react"
import tw, { styled } from "twin.macro"

const MenuGroup = styled.div`
  ${tw`flex flex-shrink flex-col w-full m:w-[21.5%] m:justify-start mb-3`}
`

export default MenuGroup
